// Used by both the old Spotlight (SpotlightOLD.tsx) and the redesign (redesign/Spotlight.tsx).
import React, { useState } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@bynder/design-system';
import { StyledImgWrapper } from '../SharedComponents';

interface Props {
	imageSrcMini: string;
	imageSrcLarge?: string;
}

export function ImageWithPreviewPopover({ imageSrcMini, imageSrcLarge }: Props) {
	const [showPreview, setShowPreview] = useState(false);
	const [imageIsLoaded, setImageIsLoaded] = useState(false);

	const handleMouseOver = () => {
		if (!showPreview) {
			setShowPreview(true);
		}
	};

	const handleMouseLeave = () => {
		setShowPreview(false);
		setImageIsLoaded(false);
	};

	const shouldWrapWithTooltip = showPreview && imageIsLoaded && imageSrcLarge;
	const addHiddenImageToStartDownloadingIt = showPreview && !imageIsLoaded && imageSrcLarge;

	const imageContent = (
		<StyledImgWrapper onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
			<img alt="" src={imageSrcMini} />
		</StyledImgWrapper>
	);

	return (
		<>
			{shouldWrapWithTooltip ? (
				<Tooltip
					size="medium"
					timing="delay"
					position="left"
					content={<Tooltip.Image alt="" src={imageSrcLarge} />}
					isLightTheme
				>
					{imageContent}
				</Tooltip>
			) : (
				imageContent
			)}
			{addHiddenImageToStartDownloadingIt && (
				<StyledHiddenImage
					alt=""
					src={imageSrcLarge}
					onLoad={() => setImageIsLoaded(true)}
				/>
			)}
		</>
	);
}

const StyledHiddenImage = styled.img`
	opacity: 0.01;
	width: 1px;
	height: 1px;
	overflow: hidden;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
	pointer-events: none;
	user-select: none;
`;
